import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import RoleBasedHeader from '../../components/ui/RoleBasedHeader';
import DashboardNavigation from '../../components/ui/DashboardNavigation';
import NotificationCenter from '../../components/ui/NotificationCenter';
import QuickActionPanel from '../../components/ui/QuickActionPanel';
import ActivityCard from './components/ActivityCard';
import CheckInList from './components/CheckInList';
import TaskPanel from './components/TaskPanel';
import ClassSchedule from './components/ClassSchedule';
import MemberLookup from './components/MemberLookup';
import QuickStats from './components/QuickStats';
import POSWidget from './components/POSWidget';

import Button from '../../components/ui/Button';

const StaffDashboard = () => {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([
  {
    id: 1,
    title: "Equipment Maintenance",
    description: "Treadmill #3 requires inspection and servicing",
    priority: "high",
    category: "Maintenance",
    dueTime: "2:00 PM",
    completed: false
  },
  {
    id: 2,
    title: "Member Service Request",
    description: "Sarah Johnson requested locker assignment change",
    priority: "medium",
    category: "Member Service",
    dueTime: "3:30 PM",
    completed: false
  },
  {
    id: 3,
    title: "Inventory Check",
    description: "Verify protein shake stock levels before weekend",
    priority: "medium",
    category: "Inventory",
    dueTime: "5:00 PM",
    completed: false
  },
  {
    id: 4,
    title: "Clean Locker Rooms",
    description: "Scheduled deep cleaning of men\'s locker room",
    priority: "low",
    category: "Cleaning",
    dueTime: "6:00 PM",
    completed: true
  },
  {
    id: 5,
    title: "Update Class Schedule",
    description: "Post tomorrow\'s class schedule on notice board",
    priority: "low",
    category: "Administration",
    dueTime: "4:00 PM",
    completed: false
  }]
  );

  const activityData = [
  {
    icon: "Users",
    iconColor: "var(--color-primary)",
    title: "Current Members",
    value: "47",
    change: "+12% from yesterday",
    changeType: "positive"
  },
  {
    icon: "Calendar",
    iconColor: "var(--color-accent)",
    title: "Classes Today",
    value: "8",
    change: "2 ongoing",
    changeType: "neutral"
  },
  {
    icon: "DollarSign",
    iconColor: "var(--color-success)",
    title: "Today\'s Revenue",
    value: "$1,247",
    change: "+8% from average",
    changeType: "positive"
  },
  {
    icon: "AlertTriangle",
    iconColor: "var(--color-warning)",
    title: "Pending Tasks",
    value: "4",
    change: "2 high priority",
    changeType: "neutral"
  }];


  const quickStatsData = [
  {
    icon: "UserCheck",
    iconColor: "var(--color-primary)",
    bgColor: "bg-primary/10",
    value: "142",
    label: "Check-ins Today",
    trend: "+15%",
    trendDirection: "up"
  },
  {
    icon: "UserPlus",
    iconColor: "var(--color-success)",
    bgColor: "bg-success/10",
    value: "3",
    label: "New Registrations",
    trend: "+2",
    trendDirection: "up"
  },
  {
    icon: "CreditCard",
    iconColor: "var(--color-accent)",
    bgColor: "bg-accent/10",
    value: "$847",
    label: "POS Sales",
    trend: "+12%",
    trendDirection: "up"
  },
  {
    icon: "Clock",
    iconColor: "var(--color-warning)",
    bgColor: "bg-warning/10",
    value: "6h 30m",
    label: "Shift Time",
    trend: "1h 30m left",
    trendDirection: "down"
  }];


  const checkInData = [
  {
    id: 1,
    name: "Sarah Johnson",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16e2660d5-1763296451457.png",
    avatarAlt: "Professional headshot of woman with blonde hair in white blouse smiling at camera",
    membershipStatus: "active",
    timestamp: "2026-01-25T16:45:00",
    location: "Front Desk"
  },
  {
    id: 2,
    name: "Michael Chen",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_165b055d2-1763293612537.png",
    avatarAlt: "Professional headshot of Asian man with short black hair in navy suit",
    membershipStatus: "active",
    timestamp: "2026-01-25T16:30:00",
    location: "Main Entrance"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18c4732a5-1763293920448.png",
    avatarAlt: "Professional headshot of Hispanic woman with long brown hair in business attire",
    membershipStatus: "expiring",
    timestamp: "2026-01-25T16:15:00",
    location: "Front Desk"
  },
  {
    id: 4,
    name: "David Thompson",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13b6f8537-1763295903462.png",
    avatarAlt: "Professional headshot of man with brown hair in casual blue shirt outdoors",
    membershipStatus: "active",
    timestamp: "2026-01-25T16:00:00",
    location: "Main Entrance"
  },
  {
    id: 5,
    name: "Lisa Anderson",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10fffe6c8-1763300890025.png",
    avatarAlt: "Professional headshot of woman with red hair in green sweater smiling warmly",
    membershipStatus: "active",
    timestamp: "2026-01-25T15:45:00",
    location: "Front Desk"
  }];


  const classScheduleData = [
  {
    id: 1,
    name: "HIIT Training",
    trainer: "Mike Johnson",
    trainerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d0768b04-1763294233630.png",
    trainerAvatarAlt: "Professional headshot of athletic male trainer with short brown hair in black gym shirt",
    startTime: "2026-01-25T17:00:00",
    endTime: "2026-01-25T18:00:00",
    room: "Studio A",
    currentCapacity: 18,
    maxCapacity: 20,
    status: "upcoming"
  },
  {
    id: 2,
    name: "Yoga Flow",
    trainer: "Sarah Williams",
    trainerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae819c95-1763294232847.png",
    trainerAvatarAlt: "Professional headshot of female yoga instructor with long dark hair in purple athletic wear",
    startTime: "2026-01-25T17:30:00",
    endTime: "2026-01-25T18:30:00",
    room: "Studio B",
    currentCapacity: 12,
    maxCapacity: 15,
    status: "upcoming"
  },
  {
    id: 3,
    name: "Spin Class",
    trainer: "James Martinez",
    trainerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16d452239-1763299445724.png",
    trainerAvatarAlt: "Professional headshot of Hispanic male cycling instructor with short black hair in red athletic shirt",
    startTime: "2026-01-25T18:00:00",
    endTime: "2026-01-25T19:00:00",
    room: "Cycling Studio",
    currentCapacity: 22,
    maxCapacity: 25,
    status: "upcoming"
  },
  {
    id: 4,
    name: "CrossFit",
    trainer: "Alex Thompson",
    trainerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc09827d-1763292798642.png",
    trainerAvatarAlt: "Professional headshot of muscular male CrossFit trainer with buzz cut in black tank top",
    startTime: "2026-01-25T19:00:00",
    endTime: "2026-01-25T20:00:00",
    room: "Main Floor",
    currentCapacity: 14,
    maxCapacity: 16,
    status: "upcoming"
  }];


  const handleTaskComplete = (taskId) => {
    setTasks((prevTasks) =>
    prevTasks?.map((task) =>
    task?.id === taskId ? { ...task, completed: !task?.completed } : task
    )
    );
  };

  const handleMemberSelect = (member) => {
    navigate('/member-management', { state: { selectedMember: member } });
  };

  const handleQuickAction = (actionId) => {
    switch (actionId) {
      case 'manual-checkin':console.log('Opening manual check-in');
        break;
      case 'add-member':navigate('/member-registration');
        break;
      case 'emergency':console.log('Emergency alert triggered');
        break;
      default:
        console.log('Action:', actionId);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <RoleBasedHeader userRole="staff" userName="Alex Morgan" />
      <div className="page-content-wrapper">
        <DashboardNavigation userRole="staff" />
      </div>
      <main className="container mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
        <div className="mb-6 md:mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                Staff Dashboard
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Welcome back, Alex! Here's what's happening today.
              </p>
            </div>
            <div className="flex items-center gap-3">
              <NotificationCenter userRole="staff" />
              <Button
                variant="outline"
                iconName="Download"
                iconPosition="left"
                className="hidden md:inline-flex">

                Export Report
              </Button>
            </div>
          </div>
        </div>

        <div className="mb-6 md:mb-8">
          <QuickStats stats={quickStatsData} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 mb-6 md:mb-8">
          <div className="lg:col-span-2 space-y-6 md:space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {activityData?.map((activity, index) =>
              <ActivityCard key={index} {...activity} />
              )}
            </div>

            <CheckInList checkIns={checkInData} />

            <ClassSchedule classes={classScheduleData} />
          </div>

          <div className="space-y-6 md:space-y-8">
            <TaskPanel tasks={tasks} onTaskComplete={handleTaskComplete} />

            <MemberLookup onMemberSelect={handleMemberSelect} />

            <POSWidget />
          </div>
        </div>

        <div className="card">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-foreground">Quick Actions</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <Button
              variant="outline"
              fullWidth
              iconName="UserCheck"
              iconPosition="left"
              onClick={() => handleQuickAction('manual-checkin')}>

              Manual Check-In
            </Button>
            <Button
              variant="outline"
              fullWidth
              iconName="UserPlus"
              iconPosition="left"
              onClick={() => navigate('/member-registration')}>

              Add Member
            </Button>
            <Button
              variant="outline"
              fullWidth
              iconName="FileText"
              iconPosition="left">

              Incident Report
            </Button>
            <Button
              variant="outline"
              fullWidth
              iconName="MessageSquare"
              iconPosition="left">

              Send Message
            </Button>
          </div>
        </div>
      </main>
      <QuickActionPanel userRole="staff" onAction={handleQuickAction} />
    </div>);

};

export default StaffDashboard;